import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css']
})
export class LeadsComponent implements OnInit {

  constructor(private leadService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  output:any=[];
  //getUrl='http://192.241.151.66:5000/viewContact';

  count=0;
  search:string='';
  isShownCustomer=false
  customer:any=[];
  Pagingflag=0
  CreateLeadShown=false
  NameAlert=""
  MobileAlert=""
  EmailAlert=""
  email:any=new FormControl('', [Validators.required, Validators.email]);
  mobile:any=new FormControl('', [Validators.required, Validators.pattern("[0-9]{10}$")]);
  data={
    name:"",
    email:"",
    mobile:""
  }
  deleteId=""
  deleteName=""
//-----------------function for set deleting lead details----------
SetDeletedLead(Id:any,value:any)
{
  this.deleteId=Id;
  this.deleteName=value;
}
//-----------function for delete a lead---------
DeleteLead(){

   //-------api delete user-------------
   this.leadService.DeleteLeads('/'+this.deleteId).subscribe((res)=>{
  //---------call api for leads listing-----
     this.ngOnInit();
   })

}
  //----function for show add new leads--------
  btnClick()
  {
    //console.log("click create leads")
    //this.CreateLeadShown=true
    this.router.navigateByUrl(('admin/create-lead'));  
    
    
  }
  //----function fpr get selected lead id---------
  getValue(Id:any)
  {
    console.log("customer id=",Id)
    this.leadService.setLeadId(Id);
    document.body.scrollTop = document.documentElement.scrollTop = 0;

  }
  
  //------function for routing to edit/delete leads-----------
  LeadDetails(){
    this.router.navigateByUrl(('admin/edit-leads'));  
  }
  
  //function for going to next page
  clicks_next(){

    this.count=this.count+1;
    //-------api get()calling for next page-------------
    this.leadService.ViewLeades('?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  
  }
  
  //function for going to previous page
  clicks_previous(){
   
    this.count=this.count-1;
    if(this.count<0)
    {
      this.count=0
    }
    //-------api get()calling for previous page-------------
    this.leadService.ViewLeades('?offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    })
  
  }
  ngOnInit(): void {
      //-------api get()calling-------------
   this.leadService.ViewLeades("").subscribe((res)=>{
    this.output=res.data
  })
  }

}
